<script setup lang="ts">
import type { PropertyStatusProps } from '.';

import { useI18n } from 'vue-i18n';

import { FilterChip } from '~/components/Filters/FilterChip';

import messages from './PropertyStatus.locale.json';

const { t } = useI18n({
	useScope: 'local',
	messages
});

defineProps<PropertyStatusProps>();

const isExclusive = defineModel<boolean>('modelValue');
</script>

<template>
	<div class="flex w-full flex-col gap-5 pt-5">
		<span
			class="font-matter-sq text-lg font-normal tracking-[-0.0225rem] text-primary"
		>
			{{ t('title') }}
		</span>

		<div class="flex w-full flex-wrap gap-2">
			<FilterChip v-model="isExclusive" :label="t('labels.isExclusive')" />
		</div>
	</div>
</template>
